import FieldValidator from './FieldValidator'

export default class PatternFieldValidator extends FieldValidator {

  validateValue(value, input) {
    let pattern = input.getAttribute('pattern'),
      isValid = true
    if (pattern) {
      pattern = new RegExp(pattern)
      isValid = pattern.exec(value)
    }
    return !!isValid
  }

}